import { render, staticRenderFns } from "./customer-return.vue?vue&type=template&id=1437eee4&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./customer-return.vue?vue&type=script&lang=js&"
export * from "./customer-return.vue?vue&type=script&lang=js&"
import style0 from "./customer-return.vue?vue&type=style&index=0&id=1437eee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1437eee4",
  null
  
)

export default component.exports